<template>
<div id="app">
  <header>
    <div class="header-top">
      <h1>Medicus ERP V5</h1>
      <button class="hamburger" @click="toggleMenu">
        <span v-if="!menuOpen">&#9776;</span>
        <span v-else>&times;</span>
      </button>
    </div>
    <nav :class="{ 'nav-open': menuOpen }" class="nav-buttons">
      <router-link to="/" v-if="user" @click.native="closeMenu">
        <button>Orders</button>
      </router-link>
      <router-link to="/supplies" v-if="user" @click.native="closeMenu">
        <button>Manage Supplies</button>
      </router-link>
      <button @click="signOut" v-if="user" class="mobile-signout">Sign Out</button>
      <router-link to="/login" v-if="!user" @click.native="closeMenu">
        <button>Login</button>
      </router-link>
    </nav>
  </header>
  <main>
    <router-view></router-view>
  </main>
  <footer v-if="user">
    Logged in as: {{ user.email }}
    <button @click="signOut" class="signout-button">Sign Out</button>
  </footer>
</div>
</template>

<script>
import { supabase } from './supabase';

export default {
data() {
  return {
    user: null,
    menuOpen: false,
  };
},
async created() {
  this.checkSession();
},
methods: {
  async checkSession() {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) throw error;
      if (session) {
        this.user = session.user;
        // Redirect to orders page if on login page
        if (this.$route.path === '/login') {
          this.$router.push('/');
        }
      } else {
        this.$router.push('/login');
      }
    } catch (error) {
      console.error('Error checking session:', error);
      this.$router.push('/login');
    }
  },
  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Error signing out:', error);
    } else {
      this.user = null;
      this.$router.push('/login');
    }
  },
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  },
  closeMenu() {
    this.menuOpen = false;
  }
},
watch: {
  '$route'(to, from) {
    // Check session whenever the route changes
    this.checkSession();
    // Optionally, close the mobile menu on route change
    this.menuOpen = false;
  }
}
};
</script>

<style scoped>
/* Header and basic layout */
header {
background-color: #343a40;
color: white;
padding: 15px;
position: relative;
box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Top header with title and hamburger */
.header-top {
display: flex;
align-items: center;
justify-content: space-between;
}

header h1 {
font-size: 24px;
margin: 0;
}

/* Hamburger button for mobile */
.hamburger {
background: none;
border: none;
font-size: 2rem;
color: white;
cursor: pointer;
display: none; /* hidden on larger screens */
}

/* Navigation styles */
.nav-buttons {
display: flex;
justify-content: center;
gap: 10px;
margin-top: 10px;
}

/* Hide nav by default on small screens */
.nav-buttons button, 
.nav-buttons a {
text-decoration: none;
}

/* Desktop styling for nav buttons */
.nav-buttons button {
padding: 10px 15px;
background-color: #007bff;
color: white;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s ease;
}

.nav-buttons button:hover {
background-color: #0056b3;
}

/* Desktop nav visible on larger screens */
@media (min-width: 768px) {
.hamburger {
  display: none;
}
.nav-buttons {
  display: flex;
}
}

/* Mobile-friendly styling */
@media (max-width: 767px) {
.hamburger {
  display: block;
}
.nav-buttons {
  flex-direction: column;
  align-items: center;
  display: none;
}
.nav-buttons.nav-open {
  display: flex;
}
.nav-buttons button,
.nav-buttons a {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
.mobile-signout {
  background-color: #dc3545;
}
}

/* Main content and footer styling */
main {
padding: 20px;
}

footer {
background-color: #f8f9fa;
padding: 10px;
text-align: center;
border-top: 1px solid #e0e0e0;
}

.signout-button {
padding: 8px 12px;
background-color: #dc3545;
color: white;
border: none;
border-radius: 5px;
cursor: pointer;
}

.signout-button:hover {
background-color: #c82333;
}
</style>